<template>
  <el-container class="settings">
    <el-container class="main-container">
      <el-main class="content">
        <div class="settings-title">
          <img
            src="@assets/codeScan/settings-icon.png"
            alt="Settings Icon"
            class="settings-icon"
          />
          <h2>{{ $t('settings.title') }}</h2>
        </div>
        <div class="settings-main">
          <section class="profile-info">
            <div class="section-header">
              <img
                src="@assets/codeScan/account-circle.png"
                alt="Profile Icon"
                class="section-icon"
              />
              <h2>{{ $t('settings.profileInfo.title') }}</h2>
              <div class="section-line"></div>
            </div>
            <el-form
              :model="profile"
              label-width="120px"
            >
              <el-row
                :gutter="2"
                align="center"
              >
                <el-col :span="24">
                  <el-form-item :label="$t('settings.profileInfo.name')">
                    <el-input
                      disabled
                      :value="`${profile.firstName} ${profile.lastName}`"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('settings.profileInfo.email')">
                    <el-input
                      disabled
                      :value="profile.primaryEmail"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('settings.profileInfo.github')">
                    <el-input
                      disabled
                      v-model="profile.github"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('settings.profileInfo.linkedin')">
                    <el-input
                      disabled
                      v-model="profile.linkedin"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('settings.profileInfo.country')">
                    <el-select
                      size="mini"
                      v-model="profile.country"
                      filterable
                      clearable
                      :placeholder="$t('settings.profileInfo.selectCountry')"
                    >
                      <el-option
                        v-for="item in countryList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                    <el-button
                      class="saveButton"
                      @click="saveProfile"
                      :loading="saveLoading"
                      size="mini"
                    >{{ $t('settings.profileInfo.save') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </section>
          <section class="notification">
            <div class="section-header">
              <img
                src="@assets/codeScan/md-notifications_active.png"
                alt="Notification Icon"
                class="section-icon"
              />
              <h2>{{ $t('settings.notification.title') }}</h2>
              <div class="section-line"></div>
            </div>
            <div class="notification-ms">{{ $t('settings.notification.receiver') }}</div>
            <el-form
              :model="notification"
              label-width="120px"
              class="notifForm"
            >
              <!-- <el-row :gutter="20">
                <el-col :span="3">
                  <el-form-item :label="$t('settings.notification.phone')">
                    <el-checkbox v-model="notification.phone">
                      <el-input
                        size="mini"
                        v-model="notification.areaCode"
                        :placeholder="$t('settings.notification.phoneAreaCode')"
                      ></el-input>
                    </el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="">
                    <el-input
                      class="notif-phone"
                      v-model="notification.areaCode"
                      :placeholder="$t('settings.notification.phoneNumber')"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item :label="$t('settings.notification.email')">
                    <el-input
                      v-model="notification.emailAddress"
                      class="notif-email"
                      :placeholder="$t('settings.notification.emailPlaceholder')"
                      size="mini"
                    ></el-input>
                    <el-button
                      class="notif-button saveButton"
                      size="mini"
                      :loading="notificationLoading"
                      @click="saveNotification"
                    >{{ $t('settings.notification.save') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </section>
          <section class="payment">
            <div class="section-header">
              <img
                src="@assets/payment.png"
                alt="Notification Icon"
                class="section-icon"
              />
              <h2>{{ $t('settings.payment.paymentRecord') }}</h2>
              <div class="section-line"></div>
            </div>
            <el-table
              :data="paymentRecords"
              :empty-text="$t('settings.payment.noPaymentRecords')"
              style="width: 100%;min-height: 300px;"
            >
              <el-table-column
                prop="createdAt"
                label=""
              >
                <template slot-scope="scope">
                  {{ dateLocaleFormat(scope.row.createdAt) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="amount"
                label=""
              >
                <template slot-scope="scope">
                  {{ formatCurrency(scope.row.amount) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label=""
              >
                <template slot-scope="scope">
                  <el-tag
                    size="small"
                    effect="dark"
                    :type="scope.row.status === 'SUCCEEDED' ? 'success' : 'danger'"
                  >{{ scope.row.status === 'SUCCEEDED' ? $t('settings.payment.success') : $t('settings.payment.failed') }}</el-tag>
                </template>

              </el-table-column>
              <el-table-column
                prop="description"
                label=""
              ></el-table-column>
              <!-- <el-table-column
                label=""
                width="230"
              >
                <template #default>
                  <el-button
                    icon="el-icon-download"
                    size="mini"
                  >{{ $t('settings.payment.invoice') }}</el-button>
                  <el-button
                    icon="el-icon-download"
                    size="mini"
                  >{{ $t('settings.payment.receipt') }}</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </section>
        </div>
      </el-main>
    </el-container>
    <el-dialog
      :visible.sync="paymentDialogVisible"
      :title="$t('settings.addPaymentMethod.title')"
      @closed="handleClosed"
      width="400px"
      destroy-on-close
    >
      <div class="cardWrapper">
        <div id="card-element" />
        <el-button
          @click="handleSavePayment"
          type="primary"
          size="mini"
          :loading="submitLoading"
        >{{ $t('settings.addPaymentMethod.submit') }}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getUserInfo, updateUserInfo, getPaymentMethods, bindPaymentMethod, unbindPaymentMethod, getPaymentHistory, getNotificationSettings, updateNotificationSettings } from '@/api/base';
import country from '@/data/country';
import { stripeInit } from '@/lib/stripe';
import { dateLocaleFormat } from '@/lib/date-format';
import { formatCurrency } from '@/utils/currency';

export default {
  name: 'SettingsIndex',
  data() {
    return {
      profile: {
        github: '',
        linkedin: '',
        country: '',
        userId: '',
        primaryEmail: '',
        username: '',
        firstName: '',
        lastName: '',
      },
      notification: {
        // phone: true,
        // phoneNumber: '',
        email: false,
        emailAddress: '',
      },
      paymentDetails: {
        name: '',
        address: '',
      },
      paymentRecords: [],
      saveLoading: false,
      paymentList: [],
      paymentDialogVisible: false,
      submitLoading: false,
      notificationSettings: [],
      notificationLoading: false,
    };
  },
  computed: {
    ...mapGetters('user', ['user', 'publicEmail']),
    ...mapGetters('common', ['locale']),
    countryList() {
      const locales = this.$i18n.locale;

      return country.map((item) => ({
        label: locales.includes('en') ? item.english : item.chinese,
        value: `${item.abbr}-${item.code}`,
      }));
    },
  },
  mounted() {
    getUserInfo(this.user.id).then((res) => {
      this.profile = Vue.observable({
        ...this.profile,
        ...res,
      });
    });

    this.getPaymentList();
    this.getPaymentHistory();
    this.initPayment();
    this.getNotificationSettings();
  },
  methods: {
    formatCurrency(amount) {
      return formatCurrency(amount);
    },
    dateLocaleFormat(date) {
      return dateLocaleFormat(date, this.locale);
    },
    handleAddPayment() {
      this.paymentDialogVisible = true;

      this.$nextTick(() => {
        this.initCard();
      });
    },
    handleClosed() {
      this.paymentDialogVisible = false;
      this.cardElement.unmount();
      this.cardElement = null;
    },
    getNotificationSettings() {
      getNotificationSettings().then((data) => {
        const { notificationMethods = [] } = data || {};
        const emailInfo = notificationMethods.find((item) => item.methodType === 'email');

        this.notificationSettings = notificationMethods;
        this.notification.email = emailInfo.enabled;
        this.notification.emailAddress = emailInfo.methodAddress;
      });
    },
    getPaymentHistory() {
      getPaymentHistory({ page: 0, size: 10 }).then((res) => {
        this.paymentRecords = res.data;
      });
    },
    handleDeletePayment(paymentId) {
      unbindPaymentMethod(paymentId).then(() => {
        this.getPaymentList();
      });
    },
    initPayment() {
      if (Vue.prototype.$stripe) {
        return;
      }

      stripeInit();
    },
    initCard() {
      const appearance = {
        theme: 'stripe',
      };
      const elements = this.$stripe.elements({ appearance });
      const cardElement = elements.create('card', {
        hidePostalCode: true,
      });
      cardElement.mount('#card-element');

      this.cardElement = cardElement;
    },
    handleSavePayment() {
      this.submitLoading = true;
      this.$stripe
        .createPaymentMethod({
          type: 'card',
          card: this.cardElement,
        })
        .then(({ paymentMethod, error }) => {
          if (error) {
            console.error(error);
          } else {
            // 发送 paymentMethod.id 到你的服务器
            return this.savePaymentMethod(paymentMethod.id);
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    savePaymentMethod(paymentMethodId) {
      bindPaymentMethod(paymentMethodId).then(() => {
        this.paymentDialogVisible = false;
        this.getPaymentList();
      });
    },
    getPaymentList() {
      getPaymentMethods().then((res) => {
        this.paymentList = res.data;
      });
    },
    saveProfile() {
      this.saveLoading = true;

      updateUserInfo({ country: this.profile.country })
        .then(() => {
          this.$message.success(this.$t('settings.profileInfo.saveSuccess'));
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    saveNotification() {
      this.notificationLoading = true;

      const notificationMethods = [
        {
          methodType: 'email',
          enabled: Boolean(this.notification.emailAddress),
          methodAddress: this.notification.emailAddress,
          methodId: this.notificationSettings.find((item) => item.methodType === 'email').methodId,
        },
      ];

      updateNotificationSettings({ notificationMethods })
        .then(() => {
          this.$message.success(this.$t('settings.profileInfo.saveSuccess'));
        })
        .finally(() => {
          this.notificationLoading = false;
        });
    },
    updatePayment() {
      // Update payment details logic
    },
  },
};
</script>

<style lang="scss">
.settings {
  display: flex;
  background-color: #f5f5f5;
  border-radius: 10px;

  .saveButton {
    position: absolute;
    left: 320px;
    top: 50%;
    transform: translateY(-50%);
  }

  .cardWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;

    #card-element {
      width: 100%;
      margin-bottom: 20px;
    }
  }

  .main-container {
    display: flex;
    flex-direction: column;
  }

  .sidebar {
    // background: linear-gradient(to bottom, #E9EEF2, #fff);
    height: calc(100vh - 85px);
    margin: 50px 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  .el-menu {
    background: linear-gradient(to bottom, #e9eef2, #fff);
    height: calc(100vh - 85px);
    border-radius: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    margin: 0;
    border-radius: 10px;
    width: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
    height: 60px !important;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .logo {
      width: 180px;
    }
  }

  .main-content {
    flex: 1;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .username {
    margin-right: 10px;
  }

  .user-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .content {
    flex: 1;
    background-color: #fafafa;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .settings-main {
    background: #fff;
    border-radius: 10px;
    margin: 20px -10px;
    overflow: hidden;
  }

  .profile-info {
    padding: 10px 20px;

    .el-form-item {
      margin-bottom: 0px;
    }

    input {
      width: 300px;
    }

    button {
      background-color: #2b2b2b;
      color: #fff;
      width: 100px;
    }
  }

  .border-bottom {
    border-bottom: 2px solid #8e8e8e;
  }

  .payment-info {
    display: flex;
    margin: 20px 0px;
    span {
      margin: 10px 30px;
    }

    .add {
      display: flex;
      position: relative;
      left: 150px;
      top: 10px;
      div {
        color: #8e8e8e;
        padding-left: 15px;
        font-size: 14px;
        padding-top: 3px;
      }
    }
    .payment-icon {
      width: 50px;
      height: 50px;
      margin: -5px 30px;
    }

    .payment-del {
      width: 20px;
      height: 20px;
      position: relative;
      top: 10px;
      right: 10px;
    }
  }

  .notification {
    padding: 10px 20px;

    .notification-ms {
      color: #8e8e8e;
      position: relative;
      left: 50px;
      top: -20px;
    }
  }

  .notifForm {
    .notif-phone {
      position: relative;
      right: 100px;
      width: 205px;
    }

    .el-form-item {
      margin-bottom: 0px;
    }

    .notif-email {
      width: 280px;
    }

    .notif-button {
      background-color: #2b2b2b;
      color: #fff;
      width: 100px;
      height: 30px;
      left: 300px;
    }
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .section-icon {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }

    h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
    }

    .section-line {
      flex-grow: 1;
      height: 2px;
      background-color: #8e8e8e;
      margin-left: 10px;
    }
  }

  .settings-title {
    display: flex;
    align-items: center;
    background-color: #e0e7ef;
    padding: 20px;
    border-radius: 10px;
    margin: -10px -10px;

    .settings-icon {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    h2 {
      margin: 0;
      padding-top: 5px;
      font-size: 20px;
      font-weight: 600;
    }
  }

  .payment {
    padding: 10px 20px;

    h3 {
      padding-left: 20px;
    }

    .el-table__body-wrapper {
      left: 20px;
    }

    .el-table .cell {
      color: #2b2b2b;
    }

    .el-table__footer-wrapper,
    .el-table__header-wrapper {
      height: 0;
    }
  }

  .payment-details {
    .el-form-item {
      margin-bottom: -5px;
      position: relative;
      top: 5px;
    }
    .el-form-item__label {
      color: #000;
    }
    .pay-address {
      padding-left: 12px;
      margin: -10px 0px;
    }
    .pay-button {
      background-color: #2b2b2b;
      color: #fff;
      width: 120px;
      height: 30px;
      line-height: 5px;
      position: relative;
      right: 30px;
      top: -15px;
    }
  }

  h2 {
    margin-bottom: 20px;
  }

  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>